export default __webpack_public_path__ + "media/images/temporary/right-orders-e722996d9309c89ef4fe4fbe09c2e442.png";